import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-serif text-xl font-semibold mb-2">{title}</h2>
    <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-3">{children}</div>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="privacy-page">
      <Seo title="Privacy Policy | Libri in Circolo" description="Informativa sulla privacy di Libri in Circolo (scambiamocelo.it): quali dati trattiamo e come proteggiamo i tuoi dati personali." path="/privacy" />
      <Button asChild variant="ghost" size="sm" className="mb-4"><Link to="/"><ArrowLeft className="w-4 h-4 mr-2" />Torna al sito</Link></Button>
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center"><ShieldCheck className="w-6 h-6" /></div>
        <h1 className="text-3xl font-serif font-bold tracking-tight">Informativa sulla Privacy</h1>
      </div>
      <p className="text-sm text-muted-foreground">Ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (GDPR). Ultimo aggiornamento: giugno 2026.</p>

      <Section title="1. Titolare del trattamento">
        <p>Il Titolare del trattamento dei dati è <strong>Paparelli Marco</strong>, con sede in Viale Regina Margherita 46, Roma (Italia). Per qualsiasi richiesta relativa al trattamento dei dati personali è possibile contattare il Titolare tramite i recapiti indicati nel sito.</p>
      </Section>

      <Section title="2. Dati personali trattati">
        <p>Nell'ambito del servizio "Libri in Circolo" trattiamo le seguenti categorie di dati:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Dati di registrazione</strong>: nome pubblico, indirizzo email, password (conservata in forma cifrata).</li>
          <li><strong>Dati di profilo</strong>: comune o zona, eventuale numero di telefono (facoltativo, non mostrato pubblicamente).</li>
          <li><strong>Contenuti pubblicati</strong>: annunci di libri, foto, messaggi in chat, proposte di scambio e recensioni.</li>
          <li><strong>Dati tecnici</strong>: log di accesso, indirizzo IP e cookie tecnici necessari al funzionamento.</li>
        </ul>
      </Section>

      <Section title="3. Finalità e base giuridica del trattamento">
        <ul className="list-disc pl-5 space-y-1">
          <li>Erogazione del servizio e gestione dell'account — <em>esecuzione di un contratto</em> (art. 6.1.b GDPR).</li>
          <li>Consentire lo scambio di libri e la comunicazione tra utenti — <em>esecuzione di un contratto</em>.</li>
          <li>Invio di notifiche in-app ed email relative a proposte, messaggi, lista desideri e comuni seguiti — <em>consenso</em> e/o legittimo interesse (art. 6.1.a/f).</li>
          <li>Sicurezza, prevenzione abusi e adempimenti di legge — <em>obbligo legale / legittimo interesse</em> (art. 6.1.c/f).</li>
          <li>Statistiche e miglioramento del servizio — <em>consenso</em> per i cookie non essenziali (art. 6.1.a).</li>
        </ul>
      </Section>

      <Section title="4. Modalità del trattamento e riservatezza">
        <p>I dati sono trattati con strumenti informatici e misure di sicurezza adeguate. L'indirizzo esatto e i recapiti personali non compaiono mai nel catalogo pubblico: il numero di telefono viene condiviso con un altro utente solo dopo l'accettazione di una proposta di scambio.</p>
      </Section>

      <Section title="5. Comunicazione dei dati a terzi">
        <p>I dati non sono diffusi né venduti. Possono essere trattati da fornitori che agiscono come responsabili del trattamento per conto del Titolare, esclusivamente per erogare il servizio, tra cui: fornitore di hosting/infrastruttura cloud, servizio di invio email transazionali e servizio di archiviazione delle immagini. Alcuni fornitori possono trattare dati anche al di fuori dello SEE, in tal caso sono adottate garanzie adeguate (es. clausole contrattuali standard).</p>
      </Section>

      <Section title="6. Periodo di conservazione">
        <p>I dati dell'account sono conservati fino alla cancellazione dello stesso. I contenuti relativi agli scambi possono essere conservati per il tempo necessario a gestire eventuali contestazioni e adempiere agli obblighi di legge. I log tecnici sono conservati per un periodo limitato.</p>
      </Section>

      <Section title="7. Diritti dell'interessato">
        <p>In qualità di interessato hai diritto, ai sensi degli artt. 15-22 GDPR, di: accedere ai tuoi dati, ottenerne la rettifica o la cancellazione, limitarne od opporti al trattamento, ricevere i dati in formato portabile e revocare in qualsiasi momento il consenso prestato. Hai inoltre diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali (www.garanteprivacy.it).</p>
      </Section>

      <Section title="8. Cookie">
        <p>Il sito utilizza cookie tecnici e, previo consenso, cookie analitici e di marketing. Per il dettaglio consulta la <Link to="/cookie" className="text-primary underline">Cookie Policy</Link>. Puoi modificare le tue scelte in qualsiasi momento dal link "Preferenze cookie" nel footer.</p>
      </Section>

      <Section title="9. Modifiche">
        <p>Il Titolare si riserva di aggiornare la presente informativa. Le modifiche saranno pubblicate su questa pagina con l'indicazione della data di aggiornamento.</p>
      </Section>
    </div>
  );
}
